import { gh, isExecute, vueDefineComponent } from '@syncfusion/ej2-vue-base';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
export let ItemsDirective = vueDefineComponent({
    inject: { custom: { default: null } },
    render(createElement) {
        if (!isExecute) {
            let h = !isExecute ? gh : createElement;
            let slots = null;
            if (!isNullOrUndefined(this.$slots.default)) {
                slots = !isExecute ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    },
    updated() {
        if (!isExecute && this.custom) {
            this.custom();
        }
    },
    methods: {
        getTag() {
            return 'e-items';
        }
    }
});
export const ItemsPlugin = {
    name: 'e-items',
    install(Vue) {
        Vue.component(ItemsPlugin.name, ItemsDirective);
    }
};
/**
 * 'e-timelineItem' directive represents a item of the Vue Timeline
 * It must be contained in a Timeline component(`ejs-timeline`).
 * ```html
 * <ejs-timeline>
 *  <e-items>
 *   <e-item :dotCss='e-icons e-folder' :content='Item 1' />
 *   <e-item :dotCss='e-icons e-folder' :content='Item 2' />
 *  </e-items>
 * </ejs-timeline>
 * ```
 */
export let ItemDirective = vueDefineComponent({
    render() {
        return;
    },
    methods: {
        getTag() {
            return 'e-item';
        }
    }
});
export const ItemPlugin = {
    name: 'e-item',
    install(Vue) {
        Vue.component(ItemPlugin.name, ItemDirective);
    }
};
